import { Component, Inject, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { CanonicalUrlPipe } from 'avn/shared/pipes/canonical-url.pipe';

// Logged-in areas and one-time token links must never be indexed (public provider signup stays indexable)
const INDEXABLE_PATH_PREFIXES = ['/business/provider/signup'];
const NOINDEX_PATH_PREFIXES = [
  '/business',
  '/profile',
  '/notifications',
  '/login',
  '/forgot-password',
  '/reset-password/',
  '/create-password/',
  '/create-business-password/',
  '/create-practitioner-password/',
  '/work-cover-signup/internal',
  '/thank-you',
  '/notfound',
  '/maintenance'
];

@Component({
  selector: 'app-seo-extention',
  template: ''
})
export class SeoExtentionComponent {
  constructor(
    private routr: Router,
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private dom: any,
    private canonical: CanonicalUrlPipe
  ) {}

  initialCall() {
    this.routr.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.homeMeta();
        if (this.isNoIndexPath(event.urlAfterRedirects)) {
          this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
        }
        this.updateCanonicalUrl(this.dom.URL);
      }
    });
  }

  homeMeta() {
    const title = 'Avaana | Workforce Health Support Without the Handovers';
    const description =
      'Avaana connects employers with 5,000+ credentialed allied health practitioners across preventive wellbeing, personal health support and WorkCover injury management — one platform, one governed network.';
    const preview_desc =
      'Avaana helps employers manage preventive health, personal health support & workplace injury care through one governed practitioner network and one accountable system.';
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({
      name: 'keywords',
      content: 'health center near you, telehealth services, wellness clinic, wellbeing clinics, Avaana'
    });
    this.meta.updateTag({ name: 'robots', content: 'index, follow' });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({
      property: 'og:description',
      content: preview_desc
    });
    this.meta.updateTag({
      property: 'og:image',
      content: 'https://avaana.com.au/assets/images/home_page/home-1.png'
    });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:url', content: 'https://avaana.com.au' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: preview_desc });
    this.meta.updateTag({ name: 'twitter:site', content: 'Avaana' });
    this.meta.updateTag({ name: 'twitter:url', content: 'https://avaana.com.au' });
    this.meta.updateTag({
      name: 'twitter:image',
      content: 'https://avaana.com.au/assets/images/home_page/twitter-home.png'
    });
  }

  isNoIndexPath(url: string) {
    const path = (url || '').split(/[?#]/)[0];
    const matches = (prefix: string) =>
      path === prefix || path.startsWith(prefix.endsWith('/') ? prefix : prefix + '/');
    return !INDEXABLE_PATH_PREFIXES.some(matches) && NOINDEX_PATH_PREFIXES.some(matches);
  }

  updateCanonicalUrl(url: string) {
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement = this.dom.querySelector("link[rel='canonical']") || null;
    if (element === null) {
      element = this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', this.canonical.transform(url));
  }
}
